












import { defineComponent } from "@vue/composition-api";
import { InputCCBillPurchaseDeposit } from "@scrile/api-provider/dist/api/CCBillPurchaseProvider";
import { PaymentSystemPublic } from "@scrile/api-provider/dist/api/PaymentSystemsProvider";
import emitter from "@/lib/emitter";
import { FormValues } from "@/types";
import { EVENTS } from "@/const";
import ModalView from "@/components/ModalView";
import CardEditView from "../../components/CardEditView";

export default defineComponent({
  name: "CCBill",
  components: { CardEditView, ModalView },
  props: {
    show: { type: Boolean, required: true },
    processing: { type: Boolean, required: true },
    paymentSystem: { type: Object as () => PaymentSystemPublic, required: true },
    isSubscription: { type: Boolean, default: false },
    price: { type: String },
  },
  setup(props, { emit }) {
    const getName = (nameOnCard: string) => {
      const [firstName, ...lastName] = nameOnCard.split(" ");
      return { firstName, lastName: lastName.join(" ") };
    };

    const onSubmit = async ({
      billingDetails,
      cardDetails,
      saveCard,
    }: {
      cardDetails: FormValues;
      billingDetails: FormValues;
      saveCard: boolean;
    }) => {
      const {
        cardNumber,
        expireDate: { month: expMonth, year: expYear } = { month: "", year: "" },
        cvc,
        nameOnCard,
      } = cardDetails;
      const { country, state, city, address, zip } = billingDetails;
      const { firstName, lastName } = getName(nameOnCard);

      if (!lastName) {
        emitter.emit(EVENTS.STATUS_SHOW, { text: "Name on card should contain at least 2 words" });
        return;
      }
      const data: InputCCBillPurchaseDeposit["billingDetails"] = {
        cardNumber,
        expMonth: Number(expMonth),
        expYear: new Date(`01/01/${expYear}`).getFullYear(),
        address,
        cvc,
        country,
        state,
        city,
        zip,
        firstName,
        lastName,
        saveCard,
      };
      emit("submit", data);
    };

    return {
      onSubmit,
    };
  },
});
